import './App.css';
import Footer from './components/common/Footer';
import Nav from './components/common/Nav';
import Hero from './components/home/Hero';
import FAQ from './components/common/faq';
import { Hot } from './components/home/Hot';
import { CityCafe } from './components/home/CityCafe';
import { Tycoons } from './components/home/Tycoons';
import { Resale } from './components/home/Resale';
import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import Connect from './components/connect/Connect';
import Latest from './components/home/Latest';
import { useLocation } from "react-router-dom";
import { useEffect } from 'react';
import Numbers from './components/common/Numbers';
import BhutaniContext from './components/projects/bhutaniCC/BhutaniContext';
import BhutaniCityCenter from './components/projects/bhutaniCC/BhutaniCityCenter';
import NoidaExtansion from './components/projects/noidaEXT/NoidaExtansion';
import BhutaniCyberthum from './components/projects/bhutaniCYBER/BhutaniCyberthum';
import AtsHomekraft from './components/projects/AtsHomekraft/AtsHomekraft';
import AdminLogin from './components/admin/Adminlogin';
import AdminDashboard from './components/admin/dashboard/AdminDashboard';
import Reverine from './components/projects/reverine/Reverine';
import PrestigeCity from './components/projects/prestigeCity/PrestigeCity';
import GodrejIndore from './components/projects/godrajIndore/GodrejIndore';
import Ska from './components/projects/Ska/Ska';
import NoidaAirportPlots from './components/projects/noidaAirportPlots/NoidaAirportPlots';
import PrivacyPolicy from './components/policy/PrivacyPolicy';
import Terms from './components/policy/Terms';
import About from './components/about/About';
import LodhaGoa from './components/projects/lodhaGoa/LodhaGoa';
import SobhaReality from './components/projects/SobhaReality/SobhaReality';
import AtsPious from './components/projects/AtsPious/AtsPious';
import AtsPr from './components/projects/AtsPR/AtsPr';
import AceAcreVille from './components/projects/AceAcreVille/AceAcreVille';
import Purvanchal from './components/projects/purvanchal/Purvanchal';
import GodrejSector12 from './components/projects/godrejSector-12/GodrejSector12';
import LakeViewFarms from './components/projects/lakeViewFarms/LakeViewFarms';
import GourNoidaExtension from './components/projects/gourNoidaExt/GourNoidaExtension';
import BhutaniFilmCity from './components/projects/bhutaniFilmcity/BhutaniFilmCity';
import Disclaimer from './components/policy/Disclaimer';
import CityProjects from './components/common/CityProjects';


const Home = () => {
  return (
    <>
      <Hero />
      <Latest />
      <Hot />
      <CityCafe />
      <Tycoons />
      <Resale />
      <Numbers />
      <FAQ />
    </>
  )
}



const App = () => {
  const location = useLocation();
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname,
    });
  }, [location]);


  const PublicLayout = () => {
    return (
      <>
        <Nav />
        <Outlet />
        <Footer />
      </>
    );
  }

  const ProtectedRoute = () => {
    const isAuthenticated = sessionStorage.getItem("phone");
    return isAuthenticated ? <Outlet /> : <Navigate to="/admin" replace />;
  }

  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/connect" element={<Connect />} />
        <Route path="/about" element={<About />} />

        <Route path="/bhutani-city-center" element={<BhutaniCityCenter />} />
        <Route path="/bhutani-city-center/*" element={<BhutaniContext />} />
        <Route path="/bhutani-noida-extension" element={<NoidaExtansion />} />
        <Route path="/gaur-aspire-centurian-park" element={<GourNoidaExtension />} />
        <Route path="/ats-province-d-olympia" element={<AtsHomekraft />} />

        <Route path="/godrej-reverine" element={<Reverine />} />
        <Route path="/prestige-city" element={<PrestigeCity />} />
        <Route path="/godrej-indore" element={<GodrejIndore />} />
        <Route path="/lodha-goa" element={<LodhaGoa />} />
        <Route path="/ska-estate" element={<Ska />} />
        <Route path="/residential-plot" element={<NoidaAirportPlots />} />
        <Route path="/bhutani-cyberthum" element={<BhutaniCyberthum />} />

        <Route path="/sobha-reality" element={<SobhaReality />} />
        <Route path="/ats-pious-orchards" element={<AtsPious />} />
        <Route path="/ats-picturesque-reprieves" element={<AtsPr />} />
        <Route path="/ace-acreville" element={<AceAcreVille />} />
        <Route path="/purvanchal-sunbliss" element={<Purvanchal />} />
        <Route path="/godrej-sector-12" element={<GodrejSector12 />} />
        <Route path="/lake-view-farms" element={<LakeViewFarms />} />
        <Route path="/bhutani-film-city" element={<BhutaniFilmCity />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/terms" element={<Terms />} />

        <Route path="/city/:city" element={<CityProjects />} />

        <Route path="/*" element={<Home />} />
        <Route path="/admin" element={<AdminLogin />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<AdminDashboard />} />
      </Route>
    </Routes>
  )
}

export default App;